

import React from 'react';
import logo from '../ginkgo.png';
import '../App.css';
import axios from 'axios';
import { baseURL } from '../API/url';
import { sessionManager, setupAxiosInterceptors } from '../utils/sessionManager';
import moment, { now } from 'moment';
import dayjs from 'dayjs';
import RedemptionPoolChart, {
  getActiveRedemptionTotal,
} from './RedemptionPoolChart';
import RedemptionRequestTable from './RedemptionRequestTable';
import RedemptionBookingTable from './RedemptionBookingTable';
import { buildListHeader } from '../utils/listSummary';
import {
  Form,
  DatePicker,
  Button,
  Typography,
  message,
  Radio,
  Input,
  Space,
  Descriptions,
  Modal,
  Table,
  Select,
  Collapse,
  Card,
  Row,
  Col,
  Statistic,
  Tabs,
  Divider,
  Spin,
} from 'antd';
import { withRouter } from 'react-router-dom';
import { Certificate } from 'crypto';
import { transpileModule } from 'typescript';
import {
  DollarCircleOutlined,
  TeamOutlined,
  BankOutlined,
  TrophyOutlined,
} from '@ant-design/icons';

import { PDFDocument } from 'pdf-lib';
import download from 'downloadjs';


const { Title } = Typography;
const getDefaultRedemptionPeriod = () => {
  const target = moment();
  return {
    month: target.month(),
    year: target.year(),
  };
};

interface CrataxRO {
	accountNum: string;
	intAmount: string | number;
	product: string;
	sin: string;
	taxYear: string;
	firstName: string;
	lastName: string;
	initate: string;
	fullName: string;
	street: string;
	city: string;
	province: string;
	postCode: string;
	businessNumber: string;
	businessName: string;
	accountType: string;
	submmitCode: string;
  }

interface CrataxNR4RO {
  taxYear: string;
  recpCode: string;
  recpCountryCode: string;
  recpAccount: string;
  recpId: string;
  incomeCode: string;
  currencyCode: string;
  grossIncome: number;
  taxWithheld: number;
  product: string;
  exemptionCode: string;
  recpName: string;
  street: string;
  city: string;
  province: string;
  postCode: string;
  payerName: string;
  payerAddress: string;
  payerCountryCode: string;
  payerTaxId: string;
}


// Setup axios interceptors immediately after all imports
setupAxiosInterceptors(axios);
const { Panel } = Collapse;
const { RangePicker } = DatePicker;
const { TabPane } = Tabs;
const dateFormat = 'MM-DD-YYYY';
const DB_dateFormat = 'YYYY-MM-DD';

class Portfolio extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    const defaultRedemptionPeriod = getDefaultRedemptionPeriod();

    this.state = {
      transactionData: [],
      certData: [],
      commData: [],
      redeemData: [],
      certDataAdvisor: [],
      commDataAdvisor: [],
      transactionStartDate: moment().dayOfYear(1).format(dateFormat),
      transactionEndDate: moment().format(dateFormat),
      certStartDate: moment().dayOfYear(1).format(dateFormat),
      certEndDate: moment().format(dateFormat),
      isAuthenticated: props.isAuthenticated,
      partnersData: [],
      currentAccountRecId: '',
      totalAccountValue: [],
      totalAccountsValue: 0,
      totalAccountTrailerFees: 0,
      totalAccountsTrailerFees: 0,
      certTrailerFees: [],
      displayAccountNum: '',
      displayAdvisorType: '',
      transactionProductId: '',
      certificateProductId: '',
      certificateProductName: '',
      partner: {},
      certSub_total: '',
      selectedYear: moment().dayOfYear(1).format(dateFormat),
      subTotalFeesOnYears: [
        { year: moment().subtract(9, 'years').year(), total: 0 },
        { year: moment().subtract(8, 'years').year(), total: 0 },
        { year: moment().subtract(7, 'years').year(), total: 0 },
        { year: moment().subtract(6, 'years').year(), total: 0 },
        { year: moment().subtract(5, 'years').year(), total: 0 },
        { year: moment().subtract(4, 'years').year(), total: 0 },
        { year: moment().subtract(3, 'years').year(), total: 0 },
        { year: moment().subtract(2, 'years').year(), total: 0 },
        { year: moment().subtract(1, 'years').year(), total: 0 },
        { year: moment().year(), total: 0 },
      ],
      selectedYearCommTotal: [0, 0, 0, 0, 0],
      /* 				currentMonthFeesTotal: 0,
       */ currentMonthFeesTotal: '',
      currentYear: moment().year(),
      currentMonth: moment().month(),
      isModalOpen: false,
      selectedPartnerSin: '',
      clientListData: [],
      clientList: [],
      userId: '',
      // Tax Form state
      TaxData: [],
      taxLoading: false,
      advisorId: '',
      advisorName: '',
      loginUserName: '',
      userType: '',
      totalClient: 0,
      totalAsset: 0,
      clientTotalValue: 0,
      //	selectedCommMonth: '2',
      selectedCommMonth: moment().subtract(1, 'months').month(),
      selectedCommYear: moment().format('YYYY'),
      searchText: '',
      // Redemption request section
      redemptionMonth: defaultRedemptionPeriod.month,
      redemptionYear: defaultRedemptionPeriod.year,
      dripTotal: 0,
      newPurchaseTotal: 0,
      redemptionRecords: [],
      redemptionLoading: false,
      bookingRecords: [],
      bookingLoading: false,
      totalMatch: 0,
      totalNonMatch: 0,
      totalRetracted: 0,
      matchPeriodAllocated: 0,
    };
  }

// buttons are always visible).
  static STATIC_REDEMPTION_ROWS = [
  {
    recId: 'static-1',
    clientId: '',
    advisorId: '',
    emdId: '',
    clientName: 'Annisa Ng',
    account: 'ONTF180249',
    advisorName: 'IBP',
    emdFirm: 'IBP Capital Inc',
    amount: 140361.00,
    dateRequest: '2026-06-02',
    queueNumber: 1,
    status: 'Matched',
  },
  {
    recId: 'static-2',
    clientId: '',
    advisorId: '',
    emdId: '',
    clientName: 'Libo Wang',
    account: 'FOR00090',
    advisorName: 'Angel Lin',
    emdFirm: 'Enoch Wealth Inc',
    amount: 250000.00,
    dateRequest: '2026-06-05',
    queueNumber: 2,
    status: 'Matched',
  },
  {
    recId: 'static-3',
    clientId: '',
    advisorId: '',
    emdId: '',
    clientName: 'Yen Fang Huang',
    account: 'FOR00124',
    advisorName: 'Raymond Keung',
    emdFirm: 'Waverley',
    amount: 65502.00,
    dateRequest: '2026-06-06',
    queueNumber: 3,
    status: 'Matched',
  },
  {
    recId: 'static-4',
    clientId: '',
    advisorId: '',
    emdId: '',
    clientName: 'Qian Wang',
    account: 'BCTF340952',
    advisorName: 'Ralph He',
    emdFirm: 'Raisen Pacific Wealth',
    amount: 24693.72,
    dateRequest: '2026-06-07',
    queueNumber: 4,
    status: 'Matched',
  },
  {
    recId: 'static-5',
    clientId: '',
    advisorId: '',
    emdId: '',
    clientName: 'Yanzhen Jia/ Qifei Bo',
    account: 'ON00265',
    advisorName: 'Luyang Yan',
    emdFirm: 'Enoch Wealth Inc',
    amount: 50500.00,
    dateRequest: '2026-06-08',
    queueNumber: 5,
    status: 'Matched',
  },
  {
    recId: 'static-6',
    clientId: '',
    advisorId: '',
    emdId: '',
    clientName: 'Kindson International Inc.',
    account: 'OCORP00038',
    advisorName: 'IBP',
    emdFirm: 'IBP Capital Inc',
    amount: 100500.00,
    dateRequest: '2026-06-09',
    queueNumber: 6,
    status: 'Matched',
  },
  {
    recId: 'static-7',
    clientId: '',
    advisorId: '',
    emdId: '',
    clientName: 'Alex Yuen',
    account: 'ONRF255546',
    advisorName: 'IBP',
    emdFirm: 'IBP Capital Inc',
    amount: 15000.00,
    dateRequest: '2026-06-09',
    queueNumber: 7,
    status: 'Matched',
  },
  {
    recId: 'static-8',
    clientId: '',
    advisorId: '',
    emdId: '',
    clientName: 'Ping Fu MPC',
    account: 'OCORP00006',
    advisorName: 'IBP',
    emdFirm: 'IBP Capital Inc',
    amount: 1000000.00,
    dateRequest: '2026-06-09',
    queueNumber: 8,
    status: 'Matched',
  },
  {
    recId: 'static-9',
    clientId: '',
    advisorId: '',
    emdId: '',
    clientName: 'Lian Rong Liu',
    account: 'FOR00097',
    advisorName: 'Carol Lun',
    emdFirm: 'Enoch Wealth Inc',
    amount: 200000.00,
    dateRequest: '2026-06-11',
    queueNumber: 9,
    status: 'Pending',
  },
  {
    recId: 'static-10',
    clientId: '',
    advisorId: '',
    emdId: '',
    clientName: 'Edward Kirkland Feng Xiao',
    account: 'BC00149',
    advisorName: 'Carol Lun',
    emdFirm: 'Enoch Wealth Inc',
    amount: 10000.00,
    dateRequest: '2026-06-11',
    queueNumber: 10,
    status: 'Pending',
  },
  {
    recId: 'static-11',
    clientId: '',
    advisorId: '',
    emdId: '',
    clientName: 'Dennis Tsz Wing Kong',
    account: 'BC00213',
    advisorName: 'Carol Lun',
    emdFirm: 'Enoch Wealth Inc',
    amount: 19605.61,
    dateRequest: '2026-06-11',
    queueNumber: 11,
    status: 'Pending',
  },
  {
    recId: 'static-12',
    clientId: '',
    advisorId: '',
    emdId: '',
    clientName: 'Dennis Tsz Wing Kong',
    account: 'BCTF133760',
    advisorName: 'Carol Lun',
    emdFirm: 'Enoch Wealth Inc',
    amount: 32894.88,
    dateRequest: '2026-06-14',
    queueNumber: 12,
    status: 'Pending',
  },
  {
    recId: 'static-13',
    clientId: '',
    advisorId: '',
    emdId: '',
    clientName: 'Tina Tsiao Nien Tso',
    account: 'BC00239',
    advisorName: 'Carol Lun',
    emdFirm: 'Enoch Wealth Inc',
    amount: 3697.77,
    dateRequest: '2026-06-15',
    queueNumber: 13,
    status: 'Pending',
  },
  {
    recId: 'static-14',
    clientId: '',
    advisorId: '',
    emdId: '',
    clientName: 'Tuen Yee Phyllis Chan',
    account: 'BCRF253493',
    advisorName: 'Carol Lun',
    emdFirm: 'Enoch Wealth Inc',
    amount: 7415.32,
    dateRequest: '2026-06-15',
    queueNumber: 14,
    status: 'Pending',
  },
  {
    recId: 'static-15',
    clientId: '',
    advisorId: '',
    emdId: '',
    clientName: 'Chee Chung Cheung',
    account: 'BC00209',
    advisorName: 'Carol Lun',
    emdFirm: 'Enoch Wealth Inc',
    amount: 50000.00,
    dateRequest: '2026-06-15',
    queueNumber: 15,
    status: 'Pending',
  },
  {
    recId: 'static-16',
    clientId: '',
    advisorId: '',
    emdId: '',
    clientName: 'Dan Jin',
    account: 'BCRS142731',
    advisorName: 'Carol Lun',
    emdFirm: 'Enoch Wealth Inc',
    amount: 7000.00,
    dateRequest: '2026-06-16',
    queueNumber: 16,
    status: 'Pending',
  },
  {
    recId: 'static-17',
    clientId: '',
    advisorId: '',
    emdId: '',
    clientName: 'Dan Jin',
    account: 'BCTF142729',
    advisorName: 'Carol Lun',
    emdFirm: 'Enoch Wealth Inc',
    amount: 6700.00,
    dateRequest: '2026-06-16',
    queueNumber: 17,
    status: 'Pending',
  },
  {
    recId: 'static-18',
    clientId: '',
    advisorId: '',
    emdId: '',
    clientName: 'Cheng Hsu',
    account: 'BC00123',
    advisorName: 'Carol Lun',
    emdFirm: 'Enoch Wealth Inc',
    amount: 40000.00,
    dateRequest: '2026-06-18',
    queueNumber: 18,
    status: 'Pending',
  },
  {
    recId: 'static-19',
    clientId: '',
    advisorId: '',
    emdId: '',
    clientName: 'Lin Jiang',
    account: 'ONTF207291',
    advisorName: 'IBP',
    emdFirm: 'IBP Capital Inc',
    amount: 60000.00,
    dateRequest: '2026-06-19',
    queueNumber: 19,
    status: 'Pending',
  },
  {
    recId: 'static-20',
    clientId: '',
    advisorId: '',
    emdId: '',
    clientName: 'Jian Xiong Wang',
    account: 'BCRS143966',
    advisorName: 'Carol Lun',
    emdFirm: 'Enoch Wealth Inc',
    amount: 23168.32,
    dateRequest: '2026-06-21',
    queueNumber: 20,
    status: 'Pending',
  },
  {
    recId: 'static-21',
    clientId: '',
    advisorId: '',
    emdId: '',
    clientName: 'Janet Lui',
    account: 'BCTF208115',
    advisorName: 'Carol Lun',
    emdFirm: 'Enoch Wealth Inc',
    amount: 80000.00,
    dateRequest: '2026-06-21',
    queueNumber: 21,
    status: 'Pending',
  },
  {
    recId: 'static-22',
    clientId: '',
    advisorId: '',
    emdId: '',
    clientName: 'Samuel Wong',
    account: 'ONTF173133',
    advisorName: 'Carol Lun',
    emdFirm: 'Enoch Wealth Inc',
    amount: 7000.00,
    dateRequest: '2026-06-26',
    queueNumber: 22,
    status: 'Pending',
  }
];


  componentDidMount = async () => {

    if (process.env.NODE_ENV === 'production') {
  console.log = function () {};
  console.debug = function () {};
  console.info = function () {};
}
    console.log('PortfolioAdvisor componentDidMount - This should NOT load for EMD users!');
    console.log('PortfolioAdvisor - isAuthenticated:', this.state.isAuthenticated);
    
    // Check actual session status
    const isSessionValid = sessionManager.isSessionValid();
    const sessionToken = sessionManager.getSessionToken();
    console.log('Session validation:', { isSessionValid, hasToken: !!sessionToken });
    
    if (!this.state.isAuthenticated || !isSessionValid) {
      console.log('No valid authentication/session, redirecting to login');
      this.props.history.push('/login');
      return;
    }

    try {
      while (this.state.isAuthenticated[1] === undefined) {
        await this.delay(100);
      }

      // Load regular advisor data
      await Promise.all([
        this.fetchInitialRedemptionRecordsByEmail(this.state.isAuthenticated[1]),
        this.fetchBookingRecords(),
        this.fetchMatchingFundPool(),
        this.fetchMatchSummary(),
        this.loadAdvisorData(
          this.state.isAuthenticated[1],
          this.state.isAuthenticated[1],
        ),
      ]);
/*        if (this.state.partner.emailAddress) await this.loadTaxData(this.state.partner.emailAddress);
 duplicate with loadAdvisorData() */
    } catch (error) {
      if (!this.props.isAuthenticated[0]) {
        window.location.assign('/login');
        this.render();
        return;
      } else {
        alert('No Data Record Was Found');
        this.props.history.push('/profile');
        this.render();
        return;
      }
    }
   
  };

  fetchMatchingFundPool = async () => {
    try {
      const response = await axios.get(
        `${baseURL}/matchingfundpool?month=${this.state.redemptionMonth + 1}&year=${this.state.redemptionYear}`,
        this.getAuthHeaders(),
      );
      this.setState({
        dripTotal: Number(response.data?.dripTotal) || 0,
        newPurchaseTotal: Number(response.data?.newPurchaseTotal) || 0,
      });
    } catch (error) {
      console.error('Error fetching matching fund pool:', error);
      this.setState({ dripTotal: 0, newPurchaseTotal: 0 });
    }
  };

  fetchMatchSummary = async () => {
    try {
      const response = await axios.get(
        `${baseURL}/redemptionrequest/match-summary?month=${this.state.redemptionMonth + 1}&year=${this.state.redemptionYear}`,
        this.getAuthHeaders(),
      );
      this.setState({
        totalMatch: Number(response.data?.totalMatch) || 0,
        totalNonMatch: Number(response.data?.totalNonMatch) || 0,
        totalRetracted: Number(response.data?.totalRetracted) || 0,
        matchPeriodAllocated: Number(response.data?.matchPeriodAllocated) || 0,
      });
    } catch (error) {
      console.error('Error fetching redemption match summary:', error);
      this.setState({ totalMatch: 0, totalNonMatch: 0, totalRetracted: 0, matchPeriodAllocated: 0 });
    }
  };

  // Build session auth headers
  getAuthHeaders = () => {
    const sessionToken = sessionManager.getSessionToken();
    return sessionToken
      ? { headers: { Authorization: `Bearer ${sessionToken}` } }
      : {};
  };

  // Fetch redemption requests for this advisor only (read-only)
  fetchRedemptionRecords = async (advisorId?: string, advisorName?: string) => {
    const effectiveAdvisorId = advisorId || this.state.advisorId;
    const effectiveAdvisorName = advisorName || this.state.advisorName || this.state.loginUserName;
    if (!effectiveAdvisorId && !effectiveAdvisorName) {
      this.setState({ redemptionRecords: [] });
      return;
    }
    this.setState({ redemptionLoading: true });
    try {
      const month = this.state.redemptionMonth + 1; // backend expects 1-based month
      const year = this.state.redemptionYear;
      const advisorIdQuery = effectiveAdvisorId
        ? `&advisorId=${encodeURIComponent(effectiveAdvisorId)}`
        : '';
      const advisorNameQuery = effectiveAdvisorName
        ? `&advisorName=${encodeURIComponent(effectiveAdvisorName)}`
        : '';
      const response = await axios.get(
        `${baseURL}/redemptionrequest/list?month=${month}&year=${year}${advisorIdQuery}${advisorNameQuery}`,
        this.getAuthHeaders(),
      );
      this.setState({ redemptionRecords: response.data || [], redemptionLoading: false });
    } catch (error) {
      console.error('Error fetching redemption records:', error);
      this.setState({ redemptionRecords: [], redemptionLoading: false });
    }
  };

  fetchInitialRedemptionRecordsByEmail = async (advisorEmail: string) => {
    try {
      const response = await axios.get(
        `${baseURL}/advisor/${advisorEmail}`,
        this.getAuthHeaders(),
      );
      const advisorId = response.data?.recId;
      const advisorName =
        response.data?.fullName ||
        [response.data?.firstName, response.data?.lastName].filter(Boolean).join(' ').trim();
      if (advisorId || advisorName) {
        await this.fetchRedemptionRecords(advisorId, advisorName);
      }
    } catch (error) {
      console.error('Error fetching initial advisor redemption records:', error);
    }
  };

  handleRedemptionPeriodChange = (month: number, year: number) => {
    this.setState({ redemptionMonth: month, redemptionYear: year }, () =>
      Promise.all([
        this.fetchRedemptionRecords(),
        this.fetchMatchingFundPool(),
        this.fetchMatchSummary(),
      ]),
    );
  };

  getFilteredRedemptionRows = (): any[] => {
    return this.state.redemptionRecords || [];
  };

  // Bookings are scoped to this advisor by the server; no filters are sent.
  fetchBookingRecords = async () => {
    this.setState({ bookingLoading: true });
    try {
      const response = await axios.get(
        `${baseURL}/redemptionbooking/list`,
        this.getAuthHeaders(),
      );
      this.setState({
        bookingRecords: response.data || [],
        bookingLoading: false,
      });
    } catch (error) {
      console.error('Error fetching redemption bookings:', error);
      this.setState({ bookingRecords: [], bookingLoading: false });
    }
  };

  getRedemptionByFirm = (): Array<{ firm: string; amount: number }> => {
    const totals: { [firm: string]: number } = {};
    (this.state.redemptionRecords || [])
      .filter((r: any) =>
        r.status === 'Matched' ||
        r.status === 'Completed' ||
        r.status === 'Redeemed',
      )
      .forEach((r: any) => {
      const firm = r.emdFirm || 'Unknown';
      totals[firm] = (totals[firm] || 0) + (Number(r.amount) || 0);
      });
    return Object.keys(totals).map((firm) => ({ firm, amount: totals[firm] }));
  };

  getTotalRedemption = (): number =>
    getActiveRedemptionTotal(this.state.redemptionRecords || []);

  getCommissionData = async (partnerId: any, productName: any) => {
    const commQuery = '?partnerId=' + partnerId + '&productName=' + productName;
    
    // Get session token for authorization
    const sessionToken = sessionManager.getSessionToken();
    const authHeaders = sessionToken ? {
      headers: {
        Authorization: `Bearer ${sessionToken}`
      }
    } : {};

    // Use Promise.all for consistency
    const [comm_data] = await Promise.all([
      axios.get(baseURL + '/commissiondetails' + commQuery, authHeaders),
    ]);

    this.setState({ commData: comm_data.data });
  };

  getCertsDataAdvisor = async (advisorId: any) => {
    const commQuery =
      '?advisorId=' +
      this.state.advisorId +
      '&theMonth=' +
      this.state.selectedCommMonth; // 0: Jan, 1: Feb, 2: Mar

    // Get session token for authorization
    const sessionToken = sessionManager.getSessionToken();
    const authHeaders = sessionToken ? {
      headers: {
        Authorization: `Bearer ${sessionToken}`
      }
    } : {};

    // Use Promise.all for consistency
    const [cert_data] = await Promise.all([
      axios.get(baseURL + '/advisorcommissiondetails' + commQuery, authHeaders),
    ]);

    return cert_data.data;
  };

  getAccountTrailerFeesTotal = async (recId: any, productName: any) => {
    const commQuery = '?partnerId=' + recId + '&productName=' + productName;

    // Get session token for Authorization headers
    const sessionToken = sessionManager.getSessionToken();
    const authHeaders = sessionToken ? { 
      headers: { Authorization: `Bearer ${sessionToken}` } 
    } : {};

    // Use Promise.all for consistency
    const [accountTrailerFees] = await Promise.all([
      axios.get(baseURL + '/trailerfees' + commQuery, authHeaders),
    ]);

    if (accountTrailerFees.data.yearstotal === null) {
      return 0;
    } else {
      return parseFloat(
        accountTrailerFees.data.yearstotal.replace(/[^0-9.-]+/g, ''),
      ); // money type convert to number
    }
  };

  copyYearsTotal = (totalArray: any) => {
    const fiveYearsTotalArray: any = totalArray.filter(
      (item: any) =>
        item.year >=
          moment(this.state.selectedYear).subtract(4, 'years').year() &&
        item.year <= moment(this.state.selectedYear).year(),
    );
    const fiveYearsTotalValue = fiveYearsTotalArray.map(
      (item: any) => item.total,
    );
    this.setState({ selectedYearCommTotal: fiveYearsTotalValue });
  };

  sumFeesTotalOnYears = async (recId: any, productName: any) => {
    let totalFeesOnYear = this.state.subTotalFeesOnYears;

    // Get session token for authorization
    const sessionToken = sessionManager.getSessionToken();
    console.log('sumFeesTotalOnYears - session token:', sessionToken ? sessionToken.substring(0, 20) + '...' : 'null');

    // Use Promise.all to wait for all HTTP requests to complete
    await Promise.all(
      totalFeesOnYear.map(async (item: any) => {
        let commQuery =
          '?partnerId=' +
          recId +
          '&year=yearB' +
          (Number(moment().year()) - Number(item.year)).toString() +
          '&productName=' +
          productName;
        
        // Include Authorization header explicitly for Promise.all context
        const headers = sessionToken ? {
          'Authorization': `Bearer ${sessionToken}`
        } : {};
        
        console.log('Commission API call - URL:', baseURL + '/commission' + commQuery, 'Headers:', headers);
        let commission = await axios.get(baseURL + '/commission' + commQuery, { headers });
        item.total = commission.data.total;
      }),
    );

    this.setState({ subTotalFeesOnYears: totalFeesOnYear });
    this.copyYearsTotal(totalFeesOnYear);
  };

  loadTaxData = async (clientEmail?: string) => {
    this.setState({ taxLoading: true });

    const sessionToken = sessionManager.getSessionToken();
    const authHeaders = sessionToken ? {
      headers: { Authorization: `Bearer ${sessionToken}` }
    } : {};

    try {
      // Get T5 records
 			const response = await axios.get(baseURL+"/partnerRecByEmail?email="+clientEmail, authHeaders);
			const partners = response.data;
			const taxDataArray: any[] = [];
			for (let i=0; i < partners.length; i++) {
				const partner = partners[i];
				const response = await axios.get(baseURL+ (partner.countryCode === 'CA' ? "/getTaxRecord?account=" : "/getNR4Record?account=") + partner.account);
				for (let j=0; j < response.data.length; j++) {
					const taxRecord = {
						...response.data[j],
						countryCode: partner.countryCode === 'CA' ? partner.countryCode  : response.data[j].recpCountryCode
					};
					taxDataArray.push(taxRecord);
				}
			}
      this.setState({ TaxData: taxDataArray, taxLoading: false }, this.sortTaxDataByYear);
    } catch (error) {
      console.error('Error loading tax data:', error);
      this.setState({ taxLoading: false });
    }
  };

  getTransactionData = async (
    transactionStartDate: string,
    transactionEndDate: string,
    recId: string,
    product: string,
  ) => {
    const transactionQuery =
      '?transactionStartDate=' +
      transactionStartDate +
      '&transactionEndDate=' +
      transactionEndDate +
      '&recId=' +
      recId +
      '&productId=' +
      product;

    // Get session token for Authorization headers
    const sessionToken = sessionManager.getSessionToken();
    const authHeaders = sessionToken ? { 
      headers: { Authorization: `Bearer ${sessionToken}` } 
    } : {};

    // Use Promise.all for consistency
    const [transaction_data] = await Promise.all([
      axios.get(baseURL + '/transactions' + transactionQuery, authHeaders),
    ]);

    return transaction_data;
  };

  getTotalPortfolioData = async (recId: string) => {
    const total_trans = await this.getTransactionData('', '', recId, '');
    if (!total_trans || total_trans.data.length === 0) {
      return {
        total_share_S1_balance: 0,
        total_share_S2_balance: 0,
        endingCapital: 0,
        totalAccountTrailerFees: 0,
        partnerInfo: recId,
      };
    }
    const total_trans_data = total_trans.data;

    let total_share_S1_balance = 0;
    let total_share_S2_balance = 0;
    let endingCapital = 0;
    total_trans_data.forEach((tran: any) => {
      if (tran.partnership.recId === '253a1dc7-3bdc-40d9-98c9-75ca619fb035') {
        total_share_S1_balance += Number(tran.shares);
        endingCapital += Number(tran.shares) * tran.partnership.fixedShareValue;
      }
      if (tran.partnership.recId === '4097eb52-bcd6-4f56-b470-5b44e2bf6c54') {
        total_share_S2_balance += Number(tran.shares);
        endingCapital += Number(tran.shares) * tran.partnership.fixedShareValue;
      }
    });
    const partnerInfo = this.state.partnersData.filter(
      (partner: any) => partner.recId === recId,
    );
    const totalFees = await this.getAccountTrailerFeesTotal(recId, '');
    return {
      total_share_S1_balance,
      total_share_S2_balance,
      endingCapital,
      totalAccountTrailerFees: totalFees,
      partnerInfo: partnerInfo[0],
    };
  };

  getAccountPortfolio = async (recId: string) => {
    const partnerInfo = this.state.partnersData.filter(
      (partner: any) => partner.recId === recId,
    );

    // Get session token for Authorization headers
    const sessionToken = sessionManager.getSessionToken();
    const authHeaders = sessionToken ? { 
      headers: { Authorization: `Bearer ${sessionToken}` } 
    } : {};

    // Use Promise.all to coordinate multiple async operations
    const [totalFees, portfolio] = await Promise.all([
      this.getAccountTrailerFeesTotal(recId, ''),
      axios.get(baseURL + '/partnerportfolio?recId=' + recId, authHeaders),
    ]);

    return {
      total_share_S1_balance: portfolio.data.partner.shareS1,
      total_share_S2_balance: portfolio.data.partner.shareS2,
      accountTotal: parseFloat(
        portfolio.data.partner.totalValue.replace(/[^0-9.-]+/g, ''),
      ),
      totalAccountTrailerFees: totalFees,
      partnerInfo: partnerInfo[0],
    };
  };
  countTotalAccountsTrailerFees = async (recIds: string[]) => {
    const totalAccountTrailerFeesArray = await Promise.all(
      recIds.map(async (recId: string) => {
        return await this.getAccountTrailerFeesTotal(recId, '');
      }),
    );
    let allAccountsTrailerFees = 0;
    totalAccountTrailerFeesArray.forEach((value) => {
      allAccountsTrailerFees += value;
    });
    this.setState({ totalAccountsTrailerFees: allAccountsTrailerFees });
  };

  countTotalAccountsValue = async (recIds: string[]) => {
    const totalAccountValueArray = await Promise.all(
      recIds.map(async (recId: string) => {
        return await this.getAccountPortfolio(recId);
      }),
    );
    let totalAccountsValue = 0;
    let allAccountsTrailerFees = 0;
    totalAccountValueArray.forEach((value) => {
      allAccountsTrailerFees += value.totalAccountTrailerFees;
      if (value.accountTotal) {
        totalAccountsValue += value.accountTotal;
      }
    });
    this.setState({
      totalAccountsValue: totalAccountsValue.toFixed(2),
      totalAccountsTrailerFees: allAccountsTrailerFees.toFixed(2),
    });
    this.setState({ totalAccountValue: totalAccountValueArray });
  };

  rangeConfig = {
    rules: [
      {
        type: 'array' as const,
        required: true,
        message: 'Please select time!',
      },
    ],
  };

  onFinishTransaction = async (fieldsValue: any) => {
    const rangeValue = fieldsValue['range-picker'];
    const values = {
      ...fieldsValue,
      'range-picker': [
        rangeValue[0].format('MM-DD-YYYY'),
        rangeValue[1].format('MM-DD-YYYY'),
      ],
    };
    this.setState({
      transactionStartDate: values['range-picker'][0],
      transactionEndDate: values['range-picker'][1],
    });

    // Use Promise.all to wait for async operations
    const [transaction_data] = await Promise.all([
      this.getTransactionData(
        this.state.transactionStartDate,
        this.state.transactionEndDate,
        this.state.currentAccountRecId,
        this.state.transactionProductId,
      ),
    ]);

    this.setState({ transactionData: transaction_data.data });
  };

  onClickTransactionYear = async (e: any) => {
    switch (e.target.value) {
      case 'currentYear':
        this.setState({
          transactionStartDate: moment().dayOfYear(1).format('MM-DD-YYYY'),
          transactionEndDate: moment().format('MM-DD-YYYY'),
        });
        break;
      case 'latestTwoYears':
        this.setState({
          transactionStartDate: moment()
            .dayOfYear(1)
            .subtract(1, 'years')
            .format('MM-DD-YYYY'),
          transactionEndDate: moment().format('MM-DD-YYYY'),
        });
        break;
      case 'allYears':
        this.setState({
          transactionStartDate: moment()
            .dayOfYear(1)
            .subtract(9, 'years')
            .format('MM-DD-YYYY'),
          transactionEndDate: moment().format('MM-DD-YYYY'),
        });
        break;
      case 'GINKGO-S1':
        this.setState({
          transactionProductId: '253a1dc7-3bdc-40d9-98c9-75ca619fb035',
        });
        break;
      case 'GINKGO-S2':
        this.setState({
          transactionProductId: '4097eb52-bcd6-4f56-b470-5b44e2bf6c54',
        });
        break;
      case 'All':
        this.setState({ transactionProductId: '' });
        break;
    }
    await this.delay(300);
    // Use Promise.all to wait for all async operations to complete
    const [transaction_data] = await Promise.all([
      this.getTransactionData(
        this.state.transactionStartDate,
        this.state.transactionEndDate,
        this.state.currentAccountRecId,
        this.state.transactionProductId,
      ),
    ]);
    this.setState({ transactionData: transaction_data.data });
    //	this.render();
  };

  onFinishCert = async (fieldsValue: any) => {
    const rangeValue = fieldsValue['range-picker'];
    const values = {
      ...fieldsValue,
      'range-picker': [
        rangeValue[0].format('MM-DD-YYYY'),
        rangeValue[1].format('MM-DD-YYYY'),
      ],
    };
    
    // Extract the new date values
    const newCertStartDate = values['range-picker'][0];
    const newCertEndDate = values['range-picker'][1];
    
    this.setState({
      certStartDate: newCertStartDate,
      certEndDate: newCertEndDate,
    });

    // Use the new date values directly instead of this.state (which is async)
    const [cert_data] = await Promise.all([
      this.getCertData(
        newCertStartDate,
        newCertEndDate,
        this.state.currentAccountRecId,
        this.state.certificateProductId,
      ),
    ]);

    this.setState({ certData: cert_data.data });
  };

  onClickCommYear = async (e: any) => {
    switch (e.target.value) {
      case 'firstYear':
        this.setState({
          certStartDate: moment()
            .dayOfYear(1)
            .subtract(13, 'years')
            .format('MM-DD-YYYY'),
          certEndDate: moment()
            .dayOfYear(365)
            .subtract(5, 'years')
            .format('MM-DD-YYYY'),
          selectedYear: moment()
            .dayOfYear(1)
            .subtract(4, 'years')
            .format(dateFormat),
        });
        break;
      case 'secondYears':
        this.setState({
          certStartDate: moment()
            .dayOfYear(1)
            .subtract(12, 'years')
            .format('MM-DD-YYYY'),
          certEndDate: moment()
            .dayOfYear(365)
            .subtract(4, 'years')
            .format('MM-DD-YYYY'),
          selectedYear: moment()
            .dayOfYear(1)
            .subtract(3, 'years')
            .format(dateFormat),
        });
        break;
      case 'thirdYears':
        this.setState({
          certStartDate: moment()
            .dayOfYear(1)
            .subtract(11, 'years')
            .format('MM-DD-YYYY'),
          certEndDate: moment()
            .dayOfYear(365)
            .subtract(3, 'years')
            .format('MM-DD-YYYY'),
          selectedYear: moment()
            .dayOfYear(1)
            .subtract(2, 'years')
            .format(dateFormat),
        });
        break;
      case 'fourthYears':
        this.setState({
          certStartDate: moment()
            .dayOfYear(1)
            .subtract(10, 'years')
            .format('MM-DD-YYYY'),
          certEndDate: moment()
            .dayOfYear(365)
            .subtract(2, 'years')
            .format('MM-DD-YYYY'),
          selectedYear: moment()
            .dayOfYear(1)
            .subtract(1, 'years')
            .format(dateFormat),
        });
        break;
      case 'fifthYears':
        this.setState({
          certStartDate: moment()
            .dayOfYear(1)
            .subtract(9, 'years')
            .format('MM-DD-YYYY'),
          certEndDate: moment().subtract(1, 'years').format('MM-DD-YYYY'),
          selectedYear: moment().dayOfYear(1).format(dateFormat),
        });
        //				this.setState({ certStartDate: moment('01-01-2012').format('MM-DD-YYYY'), certEndDate: moment().format('MM-DD-YYYY') });
        break;
      case 'GINKGO-S1':
        this.setState({
          certificateProductId: '253a1dc7-3bdc-40d9-98c9-75ca619fb035',
          certificateProductName: 'GINKGO-S1',
        });
        break;
      case 'GINKGO-S2':
        this.setState({
          certificateProductId: '4097eb52-bcd6-4f56-b470-5b44e2bf6c54',
          certificateProductName: 'GINKGO-S2',
        });
        break;
      case 'All':
        this.setState({ certificateProductId: '', certificateProductName: '' });
        break;
    }
    /* 		const cert_data = await this.getCertData(this.state.certStartDate, this.state.certEndDate, this.state.currentAccountRecId, this.state.certificateProductId);
		this.setState({ certData: cert_data.data});
 */ await this.getCommissionData(
      this.state.currentAccountRecId,
      this.state.certificateProductName,
    );
    this.sumFeesTotalOnYears(
      this.state.currentAccountRecId,
      this.state.certificateProductName,
    );
    this.sumFeesTotalOnYears(
      this.state.currentAccountRecId,
      this.state.certificateProductName,
    );
    await this.delay(500);
    //	this.render();
  };

  delay = async (milliseconds: any) => {
    return new Promise((resolve) => {
      setTimeout(resolve, milliseconds);
    });
  };

  // Load advisor data with email parameter
  loadAdvisorData = async (userEmail: string, advisorEmail: string) => {
    let partnersQuery = '';
    console.log(
      'Loading advisor data for user:',
      userEmail,
      'and advisor:',
      advisorEmail,
    );
    
    try {
      // Get session token for Authorization headers
      const sessionToken = sessionManager.getSessionToken();
      const authHeaders = sessionToken ? { 
        headers: { Authorization: `Bearer ${sessionToken}` } 
      } : {};
      console.log('loadAdvisorData - session token:', sessionToken ? sessionToken.substring(0, 20) + '...' : 'null');
      
      // Use Promise.all to fetch user and advisor data concurrently
      console.log('Fetching user and advisor data...');
      const [user, advisor] = await Promise.all([
        axios.get(baseURL + '/user/' + userEmail, authHeaders),
        axios.get(baseURL + '/advisor/' + advisorEmail, authHeaders)
      ]);
      console.log('User and advisor data fetched successfully');

     // Store the values for immediate use
    const userId = user.data.id;
    const userType = user.data.userType;
    const advisorId = advisor.data.recId;
    const advisorName = advisor.data.fullName || advisor.data.firstName + ' ' + advisor.data.lastName || 'Advisor';
    // Logged-in advisor user's name (temp_first_name + temp_last_name), used to
    // filter the static Redemption Requests rows to this advisor only.
    const loginUserName = ((user.data.firstName || '') + ' ' + (user.data.lastName || '')).trim();

    const clientFirstTin = await axios.get(
      baseURL + '/partnertin?advisorId=' + advisorId,
      authHeaders
    );
    partnersQuery =
      '?advisorId=' +
      advisorId +
      '&partnerSin=' +
      clientFirstTin.data;
    const partners = await axios.get(
      baseURL + '/advisoraccounts' + partnersQuery,
      authHeaders
    );
    this.setState({ selectedYear: moment().dayOfYear(1).format(dateFormat) });
    await this.getAccountTrailerFeesTotal(partners.data[0].recId, '');
    this.sumFeesTotalOnYears(
      partners.data[0].recId,
      this.state.certificateProductName,
    );
    
    // Load tax data for the first partner
    await this.loadTaxData(partners.data[0].emailAddress);

    const cert_data = await this.getCertData(
      this.state.certStartDate,
      this.state.certEndDate,
      partners.data[0].recId,
      this.state.certificateProductId,
    );
    const transaction_data = await this.getTransactionData(
      this.state.transactionStartDate,
      this.state.transactionEndDate,
      partners.data[0].recId,
      this.state.transactionProductId,
    );
    const redeem_data = await this.getRedeemData(partners.data[0].recId);

    this.setState({
      transactionData: transaction_data.data,
      certData: cert_data.data,
      redeemData: redeem_data.data || '',
    });
    this.setState({
      partner: partners.data[0],
      partnersData: partners.data,
      currentAccountRecId: partners.data[0].recId,
      displayAccountNum: partners.data[0].account,
      displayAdvisorType: partners.data[0].advisorType,
    });
    const commQuery =
      '?partnerId=' + partners.data[0].recId + '&productName=' + '';
    let comm_data = await axios.get(baseURL + '/commissiondetails' + commQuery, authHeaders);
    this.setState({
      commData: comm_data.data,
      selectedYear: moment().dayOfYear(1).format(dateFormat),
    });
    await this.countTotalAccountsValue(
      partners.data.map((partnerData: any) => partnerData.recId),
    );
    const advisorCommData = await axios.get(
      baseURL +
        '/advisorcommission?email=' +
        advisorEmail +
        '&theMonth=' +
        this.state.selectedCommMonth +
        '&theYear=' +
        this.state.selectedCommYear,
      authHeaders
    ); //use provided email parameter
    this.setState({ commDataAdvisor: advisorCommData.data });
    const clients = await axios.get(
      baseURL + '/clientList?user=' + userId,
      authHeaders
    );
    this.setState({ clientListData: clients.data.partners });
    this.setState({ clientTotalValue: clients.data.clientTotalValue });
    const advisorp = await axios.get(baseURL + '/advisor/' + advisorEmail, authHeaders);
    this.setState({ userId: userId, advisorId: advisorId, advisorName: advisorName, loginUserName: loginUserName });
    // Load redemption requests for this advisor (read-only)
    this.fetchRedemptionRecords(advisorId);
    const clientsTotalAssets = await axios.post(
      baseURL + '/advisor/totals?advisorId=' + advisorId,
      {},
      authHeaders
    );
    this.setState({ totalAsset: clientsTotalAssets.data.totalAssets });
    const data: {
      key: number;
      firstName: string;
      lastName: string;
      emailAddress: string;
      phone: string;
      totalValue: string;
      totalDrip: string;
      tin: string;
    }[] = [];

    if (this.state.clientListData.length !== 0) {
      this.setState({ totalClient: this.state.clientListData.length });
      for (let i = 0; i < this.state.clientListData.length; i++) {
        let clientTotalValue = await axios.get(
          baseURL +
            '/getclienttotalvalue?tin=' +
            this.state.clientListData[i].tin,
          authHeaders
        );
        if (this.state.clientListData[i].tin !== null) {
          if (
            parseFloat(clientTotalValue.data.total.replace(/[$,]/g, '')) > 0.0
          ) {
            // active client
            data.push({
              key: i,
              firstName: this.state.clientListData[i].firstName,
              lastName:
                this.state.clientListData[i].advisorType === 'IBP'
                  ? this.state.clientListData[i].lastName + ' *IBP'
                  : this.state.clientListData[i].lastName,
              emailAddress: this.state.clientListData[i].emailAddress || '',
              phone: this.state.clientListData[i].phoneHome || '',
              totalValue: clientTotalValue.data.total, // Access the 'total' property from the 'data' property of the response
              totalDrip: clientTotalValue.data.totalDrip, // Access the 'total' property from the 'data' property of the response
              tin: this.state.clientListData[i].tin || '',
            });
          }
        }
      }
    }
    this.setState({ clientList: data });

    const totalValue = await axios.get(
      baseURL +
        '/advisorcommissiontotalbymonth?email=' +
        this.state.isAuthenticated[1] +
        '&theMonth=' +
        this.state.selectedCommMonth +
        '&theYear=' +
        this.state.selectedCommYear,
      authHeaders
    );
    this.setState({ currentMonthFeesTotal: totalValue.data });
    } catch (error) {
      console.error('Error in loadAdvisorData:', error);
      throw error; // Re-throw to trigger the "No Data Record Was Found" alert
    }
  };

  // Handle advisor list modal cancel
  onClickCertYear = async (e: any) => {
    switch (e.target.value) {
      case 'currentYear':
        this.setState({
          certStartDate: moment().dayOfYear(1).format('MM-DD-YYYY'),
          certEndDate: moment().format('MM-DD-YYYY'),
        });
        break;
      case 'latestTwoYears':
        this.setState({
          certStartDate: moment()
            .dayOfYear(1)
            .subtract(1, 'years')
            .format('MM-DD-YYYY'),
          certEndDate: moment().format('MM-DD-YYYY'),
        });
        break;
      case 'allYears':
        this.setState({
          certStartDate: moment()
            .dayOfYear(1)
            .subtract(9, 'years')
            .format('MM-DD-YYYY'),
          certEndDate: moment().format('MM-DD-YYYY'),
        });
        break;
      case 'GINKGO-S1':
        this.setState({
          certificateProductId: '253a1dc7-3bdc-40d9-98c9-75ca619fb035',
        });
        break;
      case 'GINKGO-S2':
        this.setState({
          certificateProductId: '4097eb52-bcd6-4f56-b470-5b44e2bf6c54',
        });
        break;
      case 'All':
        this.setState({ certificateProductId: '' });
        break;
    }
    await this.delay(500);

    // Use Promise.all to wait for async operations
    const [cert_data] = await Promise.all([
      this.getCertData(
        this.state.certStartDate,
        this.state.certEndDate,
        this.state.currentAccountRecId,
        this.state.certificateProductId,
      ),
    ]);

    this.setState({ certData: cert_data.data });
  };

  getCertData = async (
    certStartDate: string,
    certEndDate: string,
    recId: string,
    product: string,
  ) => {
    const certQuery =
      '?certStartDate=' +
      certStartDate +
      '&certEndDate=' +
      certEndDate +
      '&recId=' +
      recId +
      '&productId=' +
      product;

    // Get session token for Authorization headers
    const sessionToken = sessionManager.getSessionToken();
    const authHeaders = sessionToken ? { 
      headers: { Authorization: `Bearer ${sessionToken}` } 
    } : {};

    // Use Promise.all for consistency and future extensibility
    const [cert_data] = await Promise.all([
      axios.get(baseURL + '/certificates' + certQuery, authHeaders),
    ]);

    let certSubtotal = 0;
    if (cert_data.data.length !== 0) {
      cert_data.data.forEach((cert: any) => {
        certSubtotal += Number(cert.transaction[0].shares);
      });
    }
    this.setState({ certSub_total: Number(certSubtotal.toFixed(2)) });
    return cert_data;
  };

  getRedeemData = async (recId: string) => {
    // Get session token for Authorization headers
    const sessionToken = sessionManager.getSessionToken();
    const authHeaders = sessionToken ? { 
      headers: { Authorization: `Bearer ${sessionToken}` } 
    } : {};

    // Use Promise.all for consistency
    const [redeem_data] = await Promise.all([
      axios.get(baseURL + '/redeemrecord/?recId=' + recId, authHeaders),
    ]);

    return redeem_data;
  };

  handleTagChange = async (e: any) => {
    let currentAccountRecId = e.target.id;
    this.setState((prevState: any) => ({ ...prevState, currentAccountRecId }));
    const currentPartnerInfo = this.state.partnersData.filter(
      (partner: any) => partner.recId === currentAccountRecId,
    );

    // Use Promise.all to coordinate multiple async operations
    const [transaction_data, redeem_data, cert_data] = await Promise.all([
      this.getTransactionData(
        this.state.transactionStartDate,
        this.state.transactionEndDate,
        currentAccountRecId,
        this.state.transactionProductId,
      ),
      this.getRedeemData(currentAccountRecId),
      this.getCertData(
        this.state.certStartDate,
        this.state.certEndDate,
        currentAccountRecId,
        this.state.certificateProductId,
      ),
    ]);

    this.setState({
      transactionData: transaction_data.data,
      certData: cert_data.data,
      redeemData: redeem_data.data,
      displayAccountNum: currentPartnerInfo[0].account,
    });
    await this.getCommissionData(
      currentAccountRecId,
      this.state.certificateProductName,
    );
    this.setState({
      displayAccountNum: currentPartnerInfo[0].account,
      displayAdvisorType: currentPartnerInfo[0].advisorType,
      partner: currentPartnerInfo[0],
    });
    this.sumFeesTotalOnYears(
      currentAccountRecId,
      this.state.certificateProductName,
    );
    this.sumFeesTotalOnYears(
      currentAccountRecId,
      this.state.certificateProductName,
    );
  };

  showModal = () => {
    this.setState({
      isModalOpen: true,
    });
  };

  handleOk = async () => {
    console.log('selected partner sin:', this.state.selectedPartnerSin);

    // Use Promise.all for initial data loading
    const [partners] = await Promise.all([
      axios.get(
        baseURL +
          '/advisoraccounts?advisorId=' +
          this.state.advisorId +
          '&partnerSin=' +
          this.state.selectedPartnerSin,
      ),
    ]);

    this.setState({
      isModalOpen: false,
    });
    console.log('return partners:', partners.data);
    this.setState({ selectedYear: moment().dayOfYear(1).format(dateFormat) });
    this.sumFeesTotalOnYears(
      partners.data[0].recId,
      this.state.certificateProductName,
    );
    await this.getAccountTrailerFeesTotal(partners.data[0].recId, '');
    this.sumFeesTotalOnYears(
      partners.data[0].recId,
      this.state.certificateProductName,
    );

    this.setState({
      partner: partners.data[0],
      partnersData: partners.data,
      currentAccountRecId: partners.data[0].recId,
      displayAccountNum: partners.data[0].account,
      displayAdvisorType: partners.data[0].advisorType,
    });

    await this.loadTaxData(partners.data[0].emailAddress);

    // Use Promise.all for data fetching
    const [cert_data, comm_data] = await Promise.all([
      this.getCertData(
        this.state.certStartDate,
        this.state.certEndDate,
        partners.data[0].recId,
        this.state.certificateProductId,
      ),
      axios.get(
        baseURL +
          '/commissiondetails?partnerId=' +
          partners.data[0].recId +
          '&productName=' +
          '',
      ),
    ]);

    this.setState({ certData: cert_data.data, commData: comm_data.data });
    await this.countTotalAccountsValue(
      partners.data.map((partnerData: any) => partnerData.recId),
    );
  };

	sortTaxDataByYear = () => {
		const sortedTaxData = [...this.state.TaxData].sort((a, b) => {
		  return a.taxYear - b.taxYear;
		});
		this.setState({ TaxData: sortedTaxData });
	  };


  handleCancel = () => {
    this.setState({
      isModalOpen: false,
    });
  };

  handleSearch = (value) => {
    this.setState({ searchText: value });
    this.render();
  };

  renderTable = () => {
    const columns = [
      {
        title: 'First Name',
        dataIndex: 'firstName',
        key: 'firstName',
        sorter: (a: any, b: any) =>
          (a.firstName || '').localeCompare(b.firstName || ''),
      },
      {
        title: 'Last Name',
        dataIndex: 'lastName',
        key: 'lastName',
        sorter: (a: any, b: any) =>
          (a.lastName || '').localeCompare(b.lastName || ''),
      },
      {
        title: 'Phone',
        dataIndex: 'phone',
      },
      {
        title: 'Email',
        dataIndex: 'emailAddress',
      },
      {
        title: 'Total Drip',
        dataIndex: 'totalDrip',
        key: 'totalDrip',
        render: (totalDrip: string) => {
          const numericValue = parseFloat(
            totalDrip?.replace(/[$,]/g, '') || '0',
          );
          return `$${numericValue.toLocaleString()}`;
        },
        sorter: (a: any, b: any) => {
          const aValue = parseFloat(a.totalDrip?.replace(/[$,]/g, '') || '0');
          const bValue = parseFloat(b.totalDrip?.replace(/[$,]/g, '') || '0');
          return aValue - bValue;
        },
      },
      {
        title: 'Total Value',
        dataIndex: 'totalValue',
        key: 'totalValue',
        render: (totalValue: string) => {
          const numericValue = parseFloat(
            totalValue?.replace(/[$,]/g, '') || '0',
          );
          return `$${numericValue.toLocaleString()}`;
        },
        sorter: (a: any, b: any) => {
          const aValue = parseFloat(a.totalValue?.replace(/[$,]/g, '') || '0');
          const bValue = parseFloat(b.totalValue?.replace(/[$,]/g, '') || '0');
          return aValue - bValue;
        },
      },
    ];
    const rowSelection = {
      onChange: (selectedRowKey: any, selectedRow: any) => {
        this.setState({ selectedPartnerSin: selectedRow[0].tin });
      },
    };

    const data = this.state.clientList;
    const filteredData = data.filter(
      (item) =>
        // replace 'name' with the property you want to search by
        item.lastName
          .toLowerCase()
          .includes(this.state.searchText.toLowerCase()) ||
        item.firstName
          .toLowerCase()
          .includes(this.state.searchText.toLowerCase()),
    );
    return (
      <Table
        columns={columns}
        dataSource={filteredData}
        size="small"
        rowSelection={{ type: 'radio', ...rowSelection }}
      />
    );
  };

  handleYearMonthSelect = async (year: string, month: string) => {
    this.setState({ selectedCommYear: year, selectedCommMonth: month });

    // Use the advisor's email
    const emailToUse = this.state.isAuthenticated[1];

    // Use the freshly selected year/month directly. Reading this.state right
    // after setState would use the previous values (setState is async), which
    // made the list lag one selection behind the dropdowns.
    const [advisorCommData, totalValue] = await Promise.all([
      axios.get(
        baseURL +
          '/advisorcommission?email=' +
          emailToUse +
          '&theMonth=' +
          month +
          '&theYear=' +
          year,
      ),
      axios.get(
        baseURL +
          '/advisorcommissiontotalbymonth?email=' +
          emailToUse +
          '&theMonth=' +
          month +
          '&theYear=' +
          year,
      ),
    ]);

    this.setState({
      commDataAdvisor: advisorCommData.data,
      currentMonthFeesTotal: totalValue.data,
    });
  };

  	downloadT5 = async (data: CrataxRO) => {
		try {
			const url = 'https://ginkgowebsite.s3.us-east-2.amazonaws.com/t5-2024b.pdf';
			const existingPdfBytes = await fetch(url).then(res => res.arrayBuffer());
			const sinCode = (data.sin === '000000000') ? data.businessNumber : data.sin;
			const sin = await axios.get(baseURL+"/decodeSIN?sin=" + sinCode);
			// Load a PDFDocument from the existing PDF bytes
			const pdfDoc = await PDFDocument.load(existingPdfBytes, { ignoreEncryption: true });
			// Get form
			const form = pdfDoc.getForm();
			// Fill form fields
	 		form.getTextField('SIN').setText(sin.data.toString())
			form.getTextField('interest_amount').setText(data.intAmount.toString().replace('$', ''));
			form.getTextField('year').setText(data.taxYear);	
			form.getTextField('payer_name').setText(process.env.PAYER_NAME  || 'Ginkgo Investment Mortgage Corporation');
			form.getTextField('payer_street').setText(process.env.PAYER_ADDRESS1 || '243 Consumers Road, Suite 210');
			form.getTextField('payer_addr2').setText(process.env.PAYER_ADDRESS2 || 'Toronto, ON M2J 4W8');
			form.getTextField('payer_phone').setText(process.env.PAYER_PHONE || '416-901-5133');
			switch (data.accountType) {
				case '3':
				  form.getTextField('rcpt_name').setText(data.businessName);
				  break;
				case '2':
				  form.getTextField('rcpt_name').setText(data.fullName);
				  break;
				case '1':
				  form.getTextField('rcpt_name').setText(data.firstName + ' ' + data.lastName);
				  break;
			  }
			form.getTextField('rcpt_street').setText(data.street);
			form.getTextField('rcpt_addr2').setText(data.city + ' ' + data.province + ' ' + data.postCode);
			form.getTextField('rpt_code').setText(data.submmitCode);
			form.getTextField('type').setText(data.accountType);
			form.getTextField('account').setText(data.accountNum);
			form.flatten();
			// Serialize the PDFDocument to bytes (a Uint8Array)
			const pdfBytes = await pdfDoc.save();
			// Trigger the browser to download the PDF document
			download(pdfBytes, 'T5-' + data.accountNum + '-' + data.product + '-' + data.taxYear + '.pdf', 'application/pdf');
			} catch (error) {
			console.error('Error modifying PDF:', error);
			}	  
	  };

async downloadNR4(data: CrataxNR4RO) {
    try {
		  const url = 'https://ginkgowebsite.s3.us-east-2.amazonaws.com/nr4-24e.pdf';
			const existingPdfBytes = await fetch(url).then(res => res.arrayBuffer());
			const sinCode = data.recpId;
			const sin = await axios.get(baseURL+"/decodenr4sin?sin=" + sinCode);
			// Load a PDFDocument from the existing PDF bytes
			const pdfDoc = await PDFDocument.load(existingPdfBytes, { ignoreEncryption: true });
			// Get form
			const form = pdfDoc.getForm();
			// Fill form fields
	 		form.getTextField('recpId').setText(sin.data.toString());
			form.getTextField('grossIncome').setText(data.grossIncome.toString().replace('$', ''));
      form.getTextField('taxWithheld').setText((data.taxWithheld.toString()).replace('$', ''));
			form.getTextField('taxYear').setText(data.taxYear);	
			form.getTextField('payerName').setText(process.env.PAYER_NAME  || 'Ginkgo Investment Mortgage Corporation');
			form.getTextField('payerAddress1').setText(process.env.PAYER_ADDRESS1 || '243 Consumers Road, Suite 210');
  		form.getTextField('payerAddress2').setText(process.env.PAYER_ADDRESS2 || 'Toronto, ON, CANADA M2J 4W8');  
			form.getTextField('recpName').setText(data.recpName);
			form.getTextField('recpAddress1').setText(data.street);
			form.getTextField('recpAddress2').setText(data.city + ' ' + data.province + ' ' + 'CANADA ' + data.postCode);
			form.getTextField('recpCode').setText(data.recpCode);
			form.getTextField('currencyCode').setText("CAD");
			form.getTextField('incomeCode').setText(data.incomeCode);
			form.getTextField('exemptionCode').setText(data.exemptionCode);
			form.getTextField('countryCode').setText(data.recpCountryCode || ' ');
			form.getTextField('recpAccount').setText(data.recpAccount);
			form.getTextField('payerCountryCode').setText(data.payerCountryCode || ' ');
	//		form.getTextField('payerAccountNumber').setText(process.env.PAYER_ACCOUNT_NUMBER);
      		form.flatten();
			// Serialize the PDFDocument to bytes (a Uint8Array)
			const pdfBytes = await pdfDoc.save();
			// Trigger the browser to download the PDF document
			download(pdfBytes, 'NR4-' + data.recpAccount + '-' + data.product + '-' + data.taxYear + '.pdf', 'application/pdf');
			} catch (error) {
			console.error('Error modifying PDF:', error);
			}	  
  }

  render() {
    return (
      <div style={{ padding: '24px' }}>
        <div style={{ textAlign: 'center', marginBottom: '18px' }}>
          <Title level={2}>Ginkgo EMD Dashboard</Title>
          <div style={{ marginTop: '8px' }}>
            <Title level={4} style={{ color: '#1890ff', margin: 0 }}>
              Advisor Portal
            </Title>
            <p style={{ color: '#666', margin: '4px 0' }}>
              {this.state.isAuthenticated[1] || 'User Email'}
            </p>
          </div>
        </div>

        {/* Early Access Program */}
        <RedemptionPoolChart
          month={this.state.redemptionMonth}
          year={this.state.redemptionYear}
          drip={this.state.dripTotal}
          newPurchase={this.state.newPurchaseTotal}
          totalRedemption={this.getTotalRedemption()}
          totalMatch={this.state.totalMatch}
          totalNonMatch={this.state.totalNonMatch}
          totalRetracted={this.state.totalRetracted}
          matchPeriodAllocated={this.state.matchPeriodAllocated}
          onPeriodChange={this.handleRedemptionPeriodChange}
          redemptionByFirm={this.getRedemptionByFirm()}
        />

        {/* Redemption Requests (read-only for Advisor) */}
        <Card
          title={(
            <span style={{ whiteSpace: 'pre' }}>
              {buildListHeader('Retraction List', this.state.redemptionRecords)}
            </span>
          )}
          style={{ marginBottom: '18px' }}
        >
          <RedemptionRequestTable
            records={this.getFilteredRedemptionRows()}
            loading={this.state.redemptionLoading}
            centerHeaders
            clientNameWrapChars={40}
            advisorWrapChars={40}
            emdWrapChars={40}
          />
        </Card>

        {/* Redemption Bookings (read-only for Advisor) */}
        <Card
          title={(
            <span style={{ whiteSpace: 'pre' }}>
              {buildListHeader('Retraction Booking List', this.state.bookingRecords)}
            </span>
          )}
          style={{ marginBottom: '18px' }}
        >
          <RedemptionBookingTable
            records={this.state.bookingRecords}
            loading={this.state.bookingLoading}
            centerHeaders
            clientNameWrapChars={40}
            advisorWrapChars={40}
            emdWrapChars={40}
          />
        </Card>

        {/* Prominent Totals Display */}
        <Card style={{ marginBottom: '18px', backgroundColor: '#f0f8ff' }}>
          <Row gutter={24} justify="center">
            <Col span={12}>
              <div style={{ textAlign: 'center' }}>
                <Title level={3} style={{ color: '#1890ff', marginBottom: '5px' }}>
                  Total Clients
                </Title>
                <Title level={1} style={{ color: '#1890ff', margin: 0 }}>
                  {this.state.totalClient}
                </Title>
              </div>
            </Col>
            <Col span={12}>
              <div style={{ textAlign: 'center' }}>
                <Title level={3} style={{ color: '#52c41a', marginBottom: '5px' }}>
                  Total Assets
                </Title>
                <Title level={1} style={{ color: '#52c41a', margin: 0 }}>
                  ${parseFloat(this.state.totalAsset?.toString().replace(/[$,]/g, '') || '0').toLocaleString()}
                </Title>
              </div>
            </Col>
          </Row>
        </Card>

        {/* Action Buttons */}
        <div style={{ textAlign: 'center', marginBottom: '18px' }}>
          <Space size="middle">
            <Button 
              type="primary" 
              size="large"
              onClick={this.showModal}
              style={{ minWidth: '150px' }}
            >
              Client List
            </Button>
          </Space>
        </div>

        {/* Current Client Information */}
        <Card title="Current Client Information" style={{ marginBottom: '18px' }}>
          <Descriptions column={2} bordered>
            <Descriptions.Item label="Email">{this.state.partner.emailAddress || ''}</Descriptions.Item>
            <Descriptions.Item label="First Name">{this.state.partner.firstName || ''}</Descriptions.Item>
            <Descriptions.Item label="Last Name">{this.state.partner.lastName || ''}</Descriptions.Item>
            <Descriptions.Item label="Full Name">{this.state.partner.fullName || ''}</Descriptions.Item>
            <Descriptions.Item label="Phone">{this.state.partner.phoneHome || ''}</Descriptions.Item>
          </Descriptions>
        </Card>

        <Title level={4} style={{ marginTop: '30px', marginBottom: '20px', textAlign: 'center' }}>Client Tax Slip Information</Title>
        <div className="ant-table" style={{ display: 'flex', flex: 'auto', marginBottom: '18px' }}>
          <table>
	                    <thead className="ant-table-thead">
	                      <tr>
							<th>Account</th>
							<th>Product</th>
	                        <th>Interest Received</th>
							<th>Tax Year</th>
	                        <th>Download</th> 
	                      </tr>
	                    </thead>  
	                  <tbody className="ant-table-tbody">
	                      {
								this.state.TaxData.map((value:any, i:number)=>(
								  <tr key={i}>
									<td>{value.countryCode==='CA' ? value.accountNum : value.recpAccount}</td>
									<td>{value.product}</td>
									<td>{value.countryCode==='CA' ? value.intAmount : value.grossIncome}</td>
									<td>{value.taxYear}</td>
									<td>
										<Button 
											onClick={() => {
												if (value.countryCode === 'CA') {
													this.downloadT5({
														accountNum: value.accountNum,
														intAmount: value.intAmount,
														product: value.product,
														sin: value.sin,
														taxYear: value.taxYear,
														firstName: value.firstName,
														lastName: value.lastName,
														initate: value.initate,
														fullName: value.fullName,
														street: value.street,
														city: value.city,
														province: value.province,
														postCode: value.postCode,
														businessNumber: value.businessNumber,
														businessName: value.businessName,
														accountType: value.accountType,
														submmitCode: value.submmitCode
													});
												} else {
													this.downloadNR4({
														taxYear: value.taxYear,
														recpCode: value.recpCode || '1',
														recpCountryCode: value.countryCode,
														recpAccount: value.recpAccount,
														recpId: value.recpId,
														incomeCode: value.incomeCode || '61',
														currencyCode: value.currencyCode || 'CAD',
														grossIncome: value.grossIncome,
														taxWithheld: value.taxWithheld || 0,
														product: value.product,
														exemptionCode: value.exemptionCode || '',
														recpName: value.recpName,
														street: value.street,
														city: value.city,
														province: value.province,
														postCode: value.postCode,
														payerName: 'Ginkgo Investment Mortgage Corporation',
														payerAddress: '243 Consumers Road, Suite 210, Toronto, ON M2J 4W8',
														payerCountryCode: 'CA',
														payerTaxId:  process.env.PAYER_ACCOUNT_NUMBER || 'F731166'
													});
												}
											}}
										>
											{value.countryCode === 'CA' ? 'T5' : 'NR4'}
										</Button>
									</td>
									</tr> 

								))
							}
 	                            <tr>
									 <td></td>
									<td></td>
									<td></td>
								</tr>           	                    
	                    </tbody> 
          </table>
        </div>
        
        {/* Client Portfolio Table */}
        <Title level={4} style={{ marginTop: '30px', marginBottom: '20px', textAlign: 'center' }}>Client  Portfolio</Title>
        <div className="ant-table" style={{ display: 'flex', flex: 'auto', marginBottom: '18px' }}>
          <table>
            <thead className="ant-table-thead">
              <tr>
                <th>Account</th>
                <th>Shares(S1) Balance</th>
                <th>Shares(S2) Balance</th>
                <th>Account Value</th>
                <th>
                  Commission/Trailer Fees(From{' '}
                  {moment().subtract(9, 'years').year()})
                </th>
              </tr>
            </thead>
            <tbody className="ant-table-tbody">
              {this.state.totalAccountValue.map((value: any, i: number) => (
                <tr key={i}>
                  <td>
                    <a
                      onClick={this.handleTagChange}
                      id={value.partnerInfo.recId}
                    >
                      {value.partnerInfo.category} ({value.partnerInfo.account})
                    </a>
                  </td>
                  <td>
                    {Number(value.total_share_S1_balance)
                      .toFixed(2)
                      .replace(/\d(?=(\d{3})+\.)/g, '$&,')}
                  </td>
                  <td>
                    {Number(value.total_share_S2_balance)
                      .toFixed(2)
                      .replace(/\d(?=(\d{3})+\.)/g, '$&,')}
                  </td>
                  <td>
                    $
                    {Number(value.accountTotal)
                      .toFixed(2)
                      .replace(/\d(?=(\d{3})+\.)/g, '$&,')}
                  </td>
                  <td>
                    <strong>${value.totalAccountTrailerFees}</strong>
                  </td>
                </tr>
              ))}
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td>
					<strong>
					  Total Value: ${Number(this.state.totalAccountsValue || 0).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,")}
					</strong>
				</td>
                <td>
                  <strong>
                    Total Fees: ${Number(this.state.totalAccountsTrailerFees || 0).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                  </strong>
                </td>
              </tr>
            </tbody>

          </table>
        </div>


        {/* Client List Modal */}
        <Modal
          title={
            <div
              style={{
                textAlign: 'center',
                fontSize: '23px',
                fontWeight: 'bold',
              }}
            >
              Client List
            </div>
          }
          open={this.state.isModalOpen}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
          width={1000}
        >
          <Input.Search
            placeholder="Name Search"
            onSearch={this.handleSearch}
            style={{ marginBottom: 16 }}
          />
          {this.renderTable()}
        </Modal>

        <Collapse defaultActiveKey={['0']} style={{ marginBottom: '18px' }}>
          <Panel
            header={`Certificates (Account:${this.state.displayAccountNum}) `}
            style={{ fontSize: '20px' }}
            key="1"
          >
            <div style={{ marginTop: '40px' }}>
              <Form
                name="time_related_controls"
                onFinish={this.onFinishCert}
                layout="inline"
                initialValues={{
                  'range-picker': [dayjs().startOf('year'), dayjs()],
                }}
              >
                {/*<Form.Item name="date-picker" label="DatePicker" {...this.config}>
							<DatePicker />
						</Form.Item>*/}
                <Form.Item name="range-picker" {...this.rangeConfig}>
                  <RangePicker format={dateFormat} />
                </Form.Item>
                <Form.Item>
                  <Button type="primary" htmlType="submit">
                    Search
                  </Button>
                </Form.Item>
                <Form.Item name="year-select">
                  <Radio.Group onChange={this.onClickCertYear}>
                    <Radio.Button value="currentYear">This Year</Radio.Button>
                    <Radio.Button value="latestTwoYears">
                      Last Two Years
                    </Radio.Button>
                    <Radio.Button value="allYears">All Years</Radio.Button>
                  </Radio.Group>
                </Form.Item>
                <Form.Item name="product-select">
                  <Radio.Group onChange={this.onClickCertYear}>
                    <Radio.Button value="GINKGO-S1">GINKGO-S1</Radio.Button>
                    <Radio.Button value="GINKGO-S2">GINKGO-S2</Radio.Button>
                    <Radio.Button value="All">All</Radio.Button>
                  </Radio.Group>
                </Form.Item>
              </Form>
            </div>
            <div className="ant-table">
              <table>
                <thead className="ant-table-thead">
                  <tr>
                    <th>Certificate #</th>
                    <th>Product</th>
                    <th>Shares</th>
                    <th>Price</th>
                    <th>Amount Paid</th>
                    <th>Date Issued</th>
                    <th>Maturity Date</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody className="ant-table-tbody">
                  {this.state.certData.map((cert: any, i: any) => (
                    <tr className="ant-table-row" key={i}>
                      <td>{cert.number}</td>
                      <td>
                        {cert.partnership ? cert.partnership.account : ''}
                      </td>
                      <td>
                        {cert.transaction.length > 0
                          ? Number(cert.transaction[0].shares)
                              .toFixed(2)
                              .replace(/\d(?=(\d{3})+\.)/g, '$&,')
                          : ''}
                      </td>
                      <td>
                        {cert.transaction.length > 0
                          ? cert.transaction[0].sharePrice
                          : ''}
                      </td>
                      <td>
                        {cert.transaction.length > 0
                          ? cert.transaction[0].amount
                          : ''}
                      </td>
                      <td>
                        {cert.issuedDate
                          ? moment(cert.issuedDate, DB_dateFormat).format(
                              dateFormat,
                            )
                          : ''}
                      </td>
                      <td>
                        {cert.maturity
                          ? moment(cert.maturity, DB_dateFormat).format(
                              dateFormat,
                            )
                          : ''}
                      </td>
                      <td>
                        {(() => {
                          if (cert.status === 0) {
                            return 'active';
                          } else if (cert.status === 1) {
                            return 'redeemed';
                          } else if (cert.status === 2) {
                            return 'transferred';
                          }
                        })()}
                      </td>
                    </tr>
                  ))}
                  <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td>
                      <strong>
                        Total: $
                        {Number(this.state.certSub_total * 10).toFixed(2)}
                      </strong>
                    </td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </Panel>
        </Collapse>

        <Collapse defaultActiveKey={['5']} style={{ marginBottom: '18px' }}>
          <Panel
            header={`Transaction History (Account:${this.state.displayAccountNum})`}
            style={{ fontSize: '20px' }}
            key="2"
          >
            <div style={{ marginTop: '40px' }}>
              <Form
                name="time_related_controls"
                onFinish={this.onFinishTransaction}
                layout="inline"
                initialValues={{
                  'range-picker': [dayjs().startOf('year'), dayjs()],
                }}
              >
                <Form.Item name="range-picker" {...this.rangeConfig}>
                  <RangePicker format={dateFormat} />
                </Form.Item>

                <Form.Item>
                  <Button type="primary" htmlType="submit">
                    Search
                  </Button>
                </Form.Item>
                <Form.Item name="year-select">
                  <Radio.Group onChange={this.onClickTransactionYear}>
                    <Radio.Button value="currentYear">This Year</Radio.Button>
                    <Radio.Button value="latestTwoYears">
                      Last Two Years
                    </Radio.Button>
                    <Radio.Button value="allYears">All Years</Radio.Button>
                  </Radio.Group>
                </Form.Item>
                <Form.Item name="product-select">
                  <Radio.Group onChange={this.onClickTransactionYear}>
                    <Radio.Button value="GINKGO-S1">GINKGO-S1</Radio.Button>
                    <Radio.Button value="GINKGO-S2">GINKGO-S2</Radio.Button>
                    <Radio.Button value="All">All</Radio.Button>
                  </Radio.Group>
                </Form.Item>
              </Form>
            </div>

            <div className="ant-table">
              <table>
                <thead className="ant-table-thead">
                  <tr>
                    <th>Date</th>
                    <th>Product</th>
                    <th>Description</th>
                    <th>Shares</th>
                    <th>Amount</th>
                    <th>Fee</th>
                    <th>Withholding</th>
                    <th>Certificate #</th>
                  </tr>
                </thead>
                <tbody className="ant-table-tbody">
                  {this.state.transactionData.map((trans: any, i: any) => (
                    <tr className="ant-table-row" key={i}>
                      <td>
                        {moment(trans.recDate, DB_dateFormat).format(
                          dateFormat,
                        )}
                      </td>
                      <td>
                        {trans.partnership ? trans.partnership.account : ''}
                      </td>
                      <td>{trans.memo}</td>
                      <td>
                        {Number(trans.shares)
                          .toFixed(2)
                          .replace(/\d(?=(\d{3})+\.)/g, '$&,')}
                      </td>
                      <td>{trans.amount}</td>
                      <td>{trans.penalty}</td>
                      <td>{trans.holdBack}</td>
                      <td>
                        {trans.certificate ? trans.certificate.number : ''}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </Panel>
        </Collapse>

        <Collapse defaultActiveKey={['5']} style={{ marginBottom: '18px' }}>
          <Panel
            header={`Redemption History (Account:${this.state.displayAccountNum})`}
            style={{ fontSize: '20px' }}
            key="3"
          >
            <div className="ant-table">
              <table>
                <thead className="ant-table-thead">
                  <tr>
                    <th>Date</th>
                    <th>Product</th>
                    <th>Amount</th>
                  </tr>
                </thead>
                <tbody className="ant-table-tbody">
                  {this.state.redeemData ? (
                    this.state.redeemData.map((redeem: any, i: any) => (
                      <tr className="ant-table-row" key={i}>
                        <td>
                          {moment(redeem.redeemDate, DB_dateFormat).format(
                            dateFormat,
                          )}
                        </td>
                        <td>
                          {redeem.productId ===
                          '4097eb52-bcd6-4f56-b470-5b44e2bf6c54'
                            ? 'S2'
                            : redeem.productId ===
                                '253a1dc7-3bdc-40d9-98c9-75ca619fb035'
                              ? 'S1'
                              : redeem.productId ===
                                  '0229bdc8-0f0f-4650-9a90-2ebda890c648'
                                ? 'Bond B'
                                : 'Bond A'}
                        </td>
                        <td>{redeem.redeemValue}</td>
                      </tr>
                    ))
                  ) : (
                    <tr className="ant-table-row">
                      <td colSpan={3}>No data available</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </Panel>
        </Collapse>

        <Collapse defaultActiveKey={['5']} style={{ marginBottom: '18px' }}>
          <Panel
            header={`Commission/Trailer Fees History (Account:${this.state.displayAccountNum})${this.state.displayAdvisorType === 'IBP' ? '*IBP' : ''} `}
            style={{ fontSize: '20px' }}
            key="4"
          >
            <div style={{ marginTop: '40px' }}>
              <Form
                name="time_related_controls"
                layout="inline"
              >
                <Form.Item name="product-select">
                  <Radio.Group onChange={this.onClickCommYear}>
                    <Radio.Button value="GINKGO-S1">GINKGO-S1</Radio.Button>
                    <Radio.Button value="GINKGO-S2">GINKGO-S2</Radio.Button>
                    <Radio.Button value="All">All</Radio.Button>
                  </Radio.Group>
                </Form.Item>
                <Form.Item name="year-select">
                  <Radio.Group style={{ marginLeft: '433px' }} onChange={this.onClickCommYear}>
                    <Radio.Button value="firstYear">
                      {moment().subtract(4, 'years').year()}
                    </Radio.Button>
                    <Radio.Button value="secondYears">
                      {moment().subtract(3, 'years').year()}
                    </Radio.Button>
                    <Radio.Button value="thirdYears">
                      {moment().subtract(2, 'years').year()}
                    </Radio.Button>
                    <Radio.Button value="fourthYears">
                      {moment().subtract(1, 'years').year()}
                    </Radio.Button>
                    <Radio.Button value="fifthYears">
                      {moment().year()}
                    </Radio.Button>
                  </Radio.Group>
                </Form.Item>
              </Form>
            </div>
            <div className="ant-table">
              <table>
                <thead className="ant-table-thead">
                  <tr>
                    <th>Certificate #</th>
                    <th>Status</th>
                    <th>Product</th>
                    <th>Investment Amount</th>
                    <th>Date Issued</th>
                    <th>Transaction Date</th>
                    <th>
                      {moment(this.state.selectedYear)
                        .subtract(4, 'years')
                        .year()}
                    </th>
                    <th>
                      {moment(this.state.selectedYear)
                        .subtract(3, 'years')
                        .year()}
                    </th>
                    <th>
                      {moment(this.state.selectedYear)
                        .subtract(2, 'years')
                        .year()}
                    </th>
                    <th>
                      {moment(this.state.selectedYear)
                        .subtract(1, 'years')
                        .year()}
                    </th>
                    <th>{moment(this.state.selectedYear).year()}</th>
                  </tr>
                </thead>
                <tbody className="ant-table-tbody">
                  {this.state.commData.length !== 0
                    ? this.state.commData.map((cert: any, i: any) => (
                        <tr className="ant-table-row" key={i}>
                          <td>
                            {cert.certificate.number
                              ? cert.certificate.number
                              : ''}
                          </td>
                          <td>
                            {cert.certificate.status === 0 ? (
                              <>
                                <td>Active</td>
                              </>
                            ) : cert.certificate.status === 1 ? (
                              <>
                                <td>Redeemed</td>
                              </>
                            ) : cert.certificate.status === 2 ? (
                              <>
                                <td>Transferred</td>
                              </>
                            ) : (
                              ''
                            )}
                          </td>
                          <td>
                            {cert.partnershipaccount
                              ? cert.partnershipaccount
                              : ''}
                          </td>
                          <td>
                            {cert.transactionamount
                              ? cert.transactionamount
                              : ''}
                          </td>
                          <td>
                            {cert.certificate.issuedDate
                              ? moment(
                                  cert.certificate.issuedDate,
                                  DB_dateFormat,
                                ).format(dateFormat)
                              : ''}
                          </td>
                          <td>
                            {cert.certificate.transferDate
                              ? moment(
                                  cert.certificate.transferDate,
                                  DB_dateFormat,
                                ).format(dateFormat)
                              : ''}
                          </td>
                          {moment(this.state.selectedYear).year() ===
                          moment().year() ? (
                            <>
                              <td>{cert.yearB4}</td>
                              <td>{cert.yearB3}</td>
                              <td>{cert.yearB2}</td>
                              <td>{cert.yearB1}</td>
                              <td>{cert.yearB0}</td>
                            </>
                          ) : moment(this.state.selectedYear).year() ===
                            moment().subtract(1, 'year').year() ? (
                            <>
                              <td>{cert.yearB5}</td>
                              <td>{cert.yearB4}</td>
                              <td>{cert.yearB3}</td>
                              <td>{cert.yearB2}</td>
                              <td>{cert.yearB1}</td>
                            </>
                          ) : moment(this.state.selectedYear).year() ===
                            moment().subtract(2, 'year').year() ? (
                            <>
                              <td>{cert.yearB6}</td>
                              <td>{cert.yearB5}</td>
                              <td>{cert.yearB4}</td>
                              <td>{cert.yearB3}</td>
                              <td>{cert.yearB2}</td>
                            </>
                          ) : moment(this.state.selectedYear).year() ===
                            moment().subtract(3, 'year').year() ? (
                            <>
                              <td>{cert.yearB7}</td>
                              <td>{cert.yearB6}</td>
                              <td>{cert.yearB5}</td>
                              <td>{cert.yearB4}</td>
                              <td>{cert.yearB3}</td>
                            </>
                          ) : moment(this.state.selectedYear).year() ===
                            moment().subtract(4, 'year').year() ? (
                            <>
                              <td>{cert.yearB8}</td>
                              <td>{cert.yearB7}</td>
                              <td>{cert.yearB6}</td>
                              <td>{cert.yearB5}</td>
                              <td>{cert.yearB4}</td>
                            </>
                          ) : (
                            <>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                            </>
                          )}
                        </tr>
                      ))
                    : ''}
                  <tr>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    {this.state.selectedYearCommTotal.length !== 0
                      ? this.state.selectedYearCommTotal.map(
                          (total: any, i: any) => (
                            <td>
                              <strong>Total: {total} </strong>
                            </td>
                          ),
                        )
                      : ''}
                  </tr>
                </tbody>
              </table>
            </div>
          </Panel>
        </Collapse>

        <Collapse defaultActiveKey={['5']} style={{ marginBottom: '18px' }}>
          <Panel
            header="Commission And Trailer Fees Payable"
            style={{ fontSize: '20px' }}
            key="5"
          >
            <Select
              defaultValue={moment().format('YYYY')}
              style={{ width: 120 }}
              onChange={(year) =>
                this.handleYearMonthSelect(year, this.state.selectedCommMonth)
              }
              options={[
                {
                  value: '2026',
                  label: '2026',
                },
                {
                  value: '2025',
                  label: '2025',
                },
                {
                  value: '2024',
                  label: '2024',
                },
                {
                  value: '2023',
                  label: '2023',
                },
              ]}
            />
            <Select
              defaultValue={moment().subtract(1, 'months').format('MMMM')}
              style={{ width: 120 }}
              onChange={(month) =>
                this.handleYearMonthSelect(this.state.selectedCommYear, month)
              }
              options={[
                {
                  value: '0',
                  label: 'January',
                },
                {
                  value: '1',
                  label: 'Febuary',
                },
                {
                  value: '2',
                  label: 'March',
                },
                {
                  value: '3',
                  label: 'April',
                },
                {
                  value: '4',
                  label: 'May',
                },
                {
                  value: '5',
                  label: 'June',
                },
                {
                  value: '6',
                  label: 'July',
                },
                {
                  value: '7',
                  label: 'Augest',
                },
                {
                  value: '8',
                  label: 'September',
                },
                {
                  value: '9',
                  label: 'October',
                },
                {
                  value: '10',
                  label: 'November',
                },
                {
                  value: '11',
                  label: 'December',
                },
              ]}
            />
            <br />
            <br />
            <div className="ant-table">
              <table>
                <thead className="ant-table-thead">
                  <tr>
                    <th>Certificate #</th>
                    <th>Account #</th>
                    <th>Account Name</th>
                    <th>Product</th>
                    <th>Investment Amount</th>
                    <th>Date Issued</th>
                    <th>Commission/Trailer Fees</th>
                  </tr>
                </thead>
                <tbody className="ant-table-tbody">
                  {this.state.commDataAdvisor.length !== 0
                    ? this.state.commDataAdvisor.map((cert: any, i: any) => (
                        <tr className="ant-table-row" key={i}>
                          <td>{cert.certNumber}</td>
                          <td>{cert.accountNumber}</td>
                          <td>{cert.accountName}</td>
                          <td>{cert.product}</td>
                          <td>{cert.investmentAmount}</td>
                          <td>{cert.issuedDate}</td>
                          {cert.payType === 'IBP' ? (
                            <td>{cert.amountPaid}*</td>
                          ) : (
                            <td>{cert.amountPaid}</td>
                          )}
                        </tr>
                      ))
                    : ''}
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td>
                    <strong>Total: {this.state.currentMonthFeesTotal} </strong>
                  </td>
                </tbody>
              </table>
            </div>
          </Panel>
        </Collapse>
      </div>
    );
  }
}

export default withRouter(Portfolio);
